// 入口
import application from './src/application'

// 服务
import systemService from './src/services/system.service'
import userService from './src/services/user.service'
import httpService from './src/services/http.service'
import dataService from './src/services/data.service'
import windowService from './src/services/window.service'

// 工具
import eventBus from './src/utils/event-bus'

// 路由
import router from './src/router'

export default application
export {
    systemService,
    userService,
    httpService,
    dataService,
    windowService,
    eventBus,
    router
}